import * as React from "react";

interface IFormDisplayChildren {
  title: string;
  children: any;
}

class FormDisplayChildren extends React.Component<IFormDisplayChildren> {
  public render() {
    const { title, children } = this.props;
    return (
      <div className="field">
        <label style={styles.headerTitleStyle}>{title}</label>
        {children}
      </div>
    );
  }
}

const styles = {
  headerTitleStyle: {
    color: "rgba(0,0,0,0.6)",
  },
};
export default FormDisplayChildren;
